import { useState } from "react";
import { Link } from "react-router-dom";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";

const Card = ({ children }) => (
  <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
    {children}
  </div>
);

const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-40 shrink-0 text-xs font-medium text-gray-500 pt-px">
        {label}:
      </span>
      <span className="text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};

const btnPrimary =
  "px-3 py-1.5 font-medium text-white bg-blue-600 hover:bg-blue-700 rounded";
const btnDanger =
  "px-3 py-1.5 font-medium text-white bg-red-600 hover:bg-red-700 rounded";

const ProjectDetailsCard = ({ project, onEdit, onDelete }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConfirmDelete = () => {
    setIsModalOpen(false);
    onDelete();
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const formatDateTime = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const clientName =
    project.client?.company_name ||
    `${project.client?.primary_user?.first_name || ""} ${
      project.client?.primary_user?.last_name || ""
    }`.trim() ||
    "";

  const clientValue = project.client?.id ? (
    <Link
      to={`/clients/${project.client.id}`}
      className="text-blue-600 hover:text-blue-800 underline font-medium"
    >
      {clientName || "—"}
    </Link>
  ) : (
    clientName
  );

  const languagePairsValue =
    project.languagePairs && project.languagePairs.length > 0 ? (
      <div className="flex flex-wrap gap-2">
        {project.languagePairs.map((lp, index) => (
          <span
            key={index}
            className="border rounded-md px-2 py-0.5 text-xs bg-gray-50 text-gray-700"
          >
            {lp.sourceLanguage?.name} → {lp.targetLanguage?.name}
          </span>
        ))}
      </div>
    ) : (
      ""
    );

  const instructionsValue = project.instructions ? (
    <div
      className="prose prose-sm max-w-none text-gray-900"
      dangerouslySetInnerHTML={{ __html: project.instructions }}
    />
  ) : (
    ""
  );

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Project Details</h2>
        <div className="flex items-center gap-2 text-sm">
          <button onClick={onEdit} className={btnPrimary}>
            Update
          </button>
          <button
            onClick={() => setIsModalOpen(true)}
            className={btnDanger}
          >
            Delete
          </button>
        </div>
      </div>

      <Card>
        <Field label="Client" value={clientValue} />
        <Field
          label="Contact Person"
          value={
            project.contactPerson
              ? `${project.contactPerson.first_name} ${project.contactPerson.last_name}`
              : ""
          }
        />
        <Field label="Project Name" value={project.project_name} />
        <Field label="Service" value={project.service?.name} />
        <Field label="Language Pairs" value={languagePairsValue} />
        <Field label="Specialization" value={project.specialization?.name} />
        <Field
          label="Start At"
          value={project.start_at ? formatDateTime(project.start_at) : ""}
        />
        <Field
          label="Deadline At"
          value={
            project.deadline_at ? formatDateTime(project.deadline_at) : ""
          }
        />
        <Field label="Instructions" value={instructionsValue} />
        <Field label="Legal Entity" value={project.legal_entity} />
        <Field label="Internal Note" value={project.internal_note} />
        <Field
          label="Created At"
          value={project.createdAt ? formatDate(project.createdAt) : ""}
        />
      </Card>

      {isModalOpen && (
        <ConfirmModal
          title="Confirm Delete"
          message="Are you sure you want to delete this project? This action cannot be undone."
          onCancel={() => setIsModalOpen(false)}
          onConfirm={handleConfirmDelete}
          confirmText="Delete"
          confirmColor="bg-red-600"
          confirmHoverColor="hover:bg-red-700"
        />
      )}
    </section>
  );
};

export default ProjectDetailsCard;
